import { useMutation } from '@apollo/client'
import { resetOrganizationCache as resetOrganizationCacheGql }
   from 'src/graphql/mutations/resetOrganizationCache.gql'

const useResetOrganizationCache = (mutationHookOptions) => {
   const [resetOrganizationCache, { called, client, data, error, loading }] =
      useMutation(resetOrganizationCacheGql, mutationHookOptions)

   return {
      resetOrganizationCache,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useResetOrganizationCache
